<template>
  <div class="tkc-photo-list" :class="{ 'is-no-photo': noPhoto }" :style="photoListStyles">
    <div class="photo-list-wrap">
      <upload-component
        class="tkc_photo_list_upload"
        :style="uploadStyles"
        :size="noPhoto ? 'large' : 'normal'"
        :disabled="maxPhoto"
        @upload="addHandler"
      />
      <gallery-component
        v-if="!noPhoto"
        class="photo-list-view"
        :wrap-width="galleryWrapWidth"
        :view-width="galleryViewWidth"
        :prev-left="prevLeft"
        :next-right="nextRight"
      >
        <draggable
          class="photo-list-drag"
          :class="{ 'is-dragging': dragging }"
          v-model="photoList"
          :options="dragOpts"
          @input="dragHandler"
          @start="startDrag"
          @end="endDrag"
          item-key="index"
        >
          <template #item="{ element, index }">
            <div
              :key="index"
              class="photo-list-item"
              :class="{ ['photo-selected']: checkedItem && checkedItem === element }"
              :style="itemStyles"
              @click="editHandler(element, index)"
              @mousemove="mousemoveHandler(index)"
              @mouseleave="mouseleaveHandler"
            >
              <editor-component
                class="tkc_photo_list_editor"
                :class="{ tkc_photo_list_editor_hover: index == hoverIndex }"
                @close="delHandler(element)"
                @editor="editHandler(element, index)"
              >
                <img-component v-if="index < viewLength || canLoad" :src="element[pathAlias]" />
              </editor-component>
            </div>
          </template>
        </draggable>
      </gallery-component>
    </div>
    <div v-if="modelValue.length > viewLength" class="photo-list-label">
      图片已上传{{ modelValue.length }}张
    </div>
  </div>
</template>

<script>
  import { nextTick } from 'vue';
  // 改这里的值要注意css那边是否有关联
  import ImgComponent from './img.vue';
  import EditorComponent from './editor.vue';
  import UploadComponent from './upload.vue';
  import GalleryComponent from '../../gallery';
  import draggable from 'vuedraggable';
  import vueUtils from '../../../utils/vue_utils';
  import { UPDATE_MODEL_EVENT } from '../../../constants/event';

  const UPLOAD_LENGTH = 1;
  const UPLOAD_WIDTH = 78;
  const IETM_WIDTH = 92;
  export default {
    name: 'PhotoListComponent',
    components: {
      ImgComponent,
      EditorComponent,
      UploadComponent,
      GalleryComponent,
      draggable,
    },
    emits: ['add-photo', UPDATE_MODEL_EVENT, 'del-photo', 'drag-photo', 'edit-photo'],
    props: {
      modelValue: {
        type: Array,
        requied: true,
      },
      viewLength: {
        type: Number,
        default: 4,
      },
      pathAlias: {
        type: String,
        default: 'filePath',
      },
      slideToDirection: {
        type: String,
        default: 'last',
      },
      max: {
        type: Number,
        default: Infinity,
      },
      itemMargin: {
        type: Number,
        default: 15,
      },
      uploadMargin: {
        type: Number,
        default: 15,
      },
      noPhotoWidth: Number,
      prevLeft: {
        type: Number,
        default: 140,
      },
      nextRight: {
        type: Number,
        default: 47,
      },
    },
    data() {
      return {
        dragging: false,
        hoverIndex: -1,
        canLoad: false,
        checkedItem: null,
      };
    },
    computed: {
      photoList: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit(UPDATE_MODEL_EVENT, value);
        },
      },
      noPhoto() {
        return this.modelValue.length === 0;
      },
      maxPhoto() {
        return this.modelValue.length >= this.max;
      },
      uploadStyles() {
        return this.noPhoto
          ? {
              margin: '5px 0 0',
              width: this.noPhotoWidth ? `${this.noPhotoWidth}px` : '',
            }
          : {
              margin: `5px ${this.uploadMargin / 2}px 0`,
              width: `${UPLOAD_WIDTH}px`,
            };
      },
      itemStyles() {
        return {
          width: `${IETM_WIDTH}px`,
          margin: `5px ${this.itemMargin / 2}px 0`,
        };
      },
      photoListStyles() {
        return { width: `${this.galleryWrapWidth + UPLOAD_LENGTH * this.uploadOuterWidth}px` };
      },
      // 自动计算传给gallery组件的参数
      galleryWrapWidth() {
        return this.viewLength * this.itemOuterWidth;
      },
      galleryViewWidth() {
        return this.modelValue.length * this.itemOuterWidth;
      },
      // draggable组件的配置
      dragOpts() {
        return {
          draggable: '.photo-list-item',
          forceFallback: true,
          filter: '.tkc_editor_item',
          scrollFn: this.scrollFn,
          preventOnFilter: false,
        };
      },
      itemOuterWidth() {
        return IETM_WIDTH + this.itemMargin;
      },
      uploadOuterWidth() {
        return UPLOAD_WIDTH + this.uploadMargin;
      },
    },
    created() {
      // 添加完图片要滑到最后
      // this.$bus?.$on('added-photo', this.addedPhoto);
    },
    mounted() {
      // 图片生成延迟加载
      if (document.readyState === 'complete') {
        this.loadImgs();
      } else {
        vueUtils.on(window, 'load', this.loadImgs);
      }

      /**
       * 首次加载默认选中第一项
       */
      if (this.modelValue && this.modelValue.length > 0) {
        this.editHandler(this.modelValue[0], 0);
      }
    },
    beforeUnmount() {
      vueUtils.off(window, 'load', this.loadImgs);
    },
    methods: {
      loadImgs() {
        this.canLoad = true;
      },
      addHandler() {
        if (this.maxPhoto) return;
        this.$emit('add-photo', this.addedPhoto);
      },
      delHandler(item) {
        const currentValue = this.modelValue.slice();
        const index = currentValue.indexOf(item);

        index > -1 && currentValue.splice(index, 1);

        this.$emit(UPDATE_MODEL_EVENT, currentValue);
        this.$emit('del-photo', item);
      },
      dragHandler(currentValue) {
        this.$emit(UPDATE_MODEL_EVENT, currentValue);
        this.$emit('drag-photo', currentValue);
      },
      editHandler(item, index) {
        this.checkedItem = item;
        this.$emit('edit-photo', item, index);
      },
      // 触发gallery组件的事件，触发滑动效果
      slideToPrev() {
        vueUtils.broadcast(this, 'Gallery', 'slide-to-prev');
      },
      slideToNext() {
        vueUtils.broadcast(this, 'Gallery', 'slide-to-next');
      },
      slideToFirst() {
        vueUtils.broadcast(this, 'Gallery', 'slide-to-first');
      },
      slideToLast() {
        vueUtils.broadcast(this, 'Gallery', 'slide-to-last');
      },
      addedPhoto() {
        // 从无图片状态添加图片，不会触发滑动到最后一张图片的效果
        // 此时子组件的数据还没更新好，要用nextTick
        !this.noPhoto &&
          nextTick(this.slideToDirection === 'last' ? this.slideToLast : this.slideToFirst);
      },
      // 排序的时候检测位置，触发滑动
      scrollFn: vueUtils.throttle(function (offsetX) {
        offsetX < 0 && this.slideToPrev();
        offsetX > 0 && this.slideToNext();
      }, 800),
      // 控制状态，是否排序中
      startDrag() {
        this.dragging = true;
      },
      endDrag() {
        this.dragging = false;
      },
      // 通过操作类来控制hover样式，因为css伪类hover无法处理一些情况
      mousemoveHandler(index) {
        if (this.dragging) return;
        if (this.hoverIndex === index) return;
        this.hoverIndex = index;
      },
      mouseleaveHandler() {
        if (this.dragging) return;
        this.hoverIndex = -1;
      },
    },
  };
</script>

<style lang="less">
  @import '../../../themes';

  .tkc-photo-list {
    position: relative;
  }

  .tkc-photo-list .photo-list-label {
    position: absolute;
    right: 7.5px;
    top: -20px;
    color: #999;
    font-size: 13px;
    line-height: normal;
  }

  .tkc-photo-list .photo-list-wrap:after {
    content: '';
    display: table;
    clear: both;
    height: 0;
    visibility: hidden;
  }

  .tkc-photo-list .photo-list-item,
  .tkc-photo-list .photo-list-view {
    display: inline-block;
    float: left;
  }

  .tkc-photo-list .photo-list-item {
    height: 78px;
  }

  .tkc-photo-list .photo-list-drag {
    overflow: hidden;
  }

  .tkc-photo-list .photo-list-item {
    cursor: move;
    position: relative;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .tkc_photo_list_upload {
    float: left;
  }

  .tkc_photo_list_editor {
    .tkc_editor_layer {
      opacity: 0;
    }
  }

  .tkc_photo_list_editor_hover {
    .tkc_editor_layer {
      opacity: 1;
    }
  }

  .tkc-photo-list .sortable-ghost {
    background-color: #eef2fc;
    border: 1px dashed @primary-color;
  }

  .tkc-photo-list .sortable-ghost > div {
    display: none;
  }

  .tkc-photo-list .sortable-fallback .photo-list-item-hover {
    display: none;
  }
</style>
